import React from "react";
import { ChatsContentType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import { Listing } from "../../../../widget/common/ui/Listing";
import ChatListItem from "./ChatListItem";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";

const ChatList: React.FC<ChatsContentType> = ({ chats, type }) => {
  const { handleClickChat, chatSelected } = ChatsContextImport();

  return (
    <>
      {chats != null && (
        <Listing>
          {(chats ?? []).map((chat, key) => (
            <ChatListItem
              key={key}
              chat={chat}
              type={type}
              handleClick={handleClickChat}
              chatSelected={chatSelected}
            />
          ))}
        </Listing>
      )}
    </>
  );
};

export default ChatList;
